import { ButtonERP } from "@finanedi.es/storybook"
import React from "react"
import { useTranslation } from "react-i18next"

export function ModalFooter({
  onCancel,
  onConfirm,
  isButtonLoading,
  cancelButtonProps,
  confirmButtonProps,
}: {
  onCancel?: React.MouseEventHandler<HTMLButtonElement>
  onConfirm?: React.MouseEventHandler<HTMLButtonElement>
  isButtonLoading?: boolean
  cancelButtonProps?: $TSMigrationFixMe
  confirmButtonProps?: $TSMigrationFixMe
}): React.JSX.Element {
  const { t } = useTranslation()
  return (
    <div className='tw-flex tw-justify-end tw-gap-4 tw-pt-2'>
      <ButtonERP
        label={`${t("bancos.modal.cancelButton")}`}
        customize={{
          type: "white",
          size: "md",
        }}
        onClick={onCancel}
        {...cancelButtonProps}
      />
      <ButtonERP
        label={`${t("bancos.modal.connectButton")}`}
        customize={{
          type: "primary",
          size: "md",
        }}
        data-disabled={isButtonLoading || confirmButtonProps?.disabled}
        loading={isButtonLoading}
        onClick={onConfirm}
        {...confirmButtonProps}
      />
    </div>
  )
}
